import { PRODUCTION, DEVELOPMENT, LOCAL_ACCOUNTS_URL } from "./const";
import { isEmpty } from "lodash";

export function accountsUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const ACCOUNTS_URL = !!process.env.REACT_APP_ACCOUNTS_URL && process.env.REACT_APP_ACCOUNTS_URL !== "" ? process.env.REACT_APP_ACCOUNTS_URL : "";
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return LOCAL_ACCOUNTS_URL;
      case PRODUCTION:
        return ACCOUNTS_URL;
      default:
        return LOCAL_ACCOUNTS_URL;
    }
  } else {
    return LOCAL_ACCOUNTS_URL;
  }
}

export const getIntelAccountsUrl = () => {
  return `${accountsUrl()}`;
};
